import Typography from '@mui/material/Typography';
import { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTWCL_Please_verify_your_identity_to_ELL,
  TXTWCL_WeXve_saved_your_detailsX,
  TXTWCL_You_can_deposit_up_to_N0X_but__ELL
} from './ES.messages.json';

const ES: React.FC = () => (
  <Typography component="div">
    <Translation tagName="p" {...TXTWCL_WeXve_saved_your_detailsX} />
    <Translation
      values={{ 0: `150 ${Currency.Euro}` }}
      {...TXTWCL_You_can_deposit_up_to_N0X_but__ELL}
    />
    <Translation tagName="p" {...TXTWCL_Please_verify_your_identity_to_ELL} />
  </Typography>
);

export default ES;
